import React from 'react';

const AddressBulkActionBar = () => <></>;

export default AddressBulkActionBar;
